/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { ContentZoneContext } from "cms/components/context";
import { isEmpty } from "lodash";
import { Fragment, useContext } from "react";
import { isRichTextEmpty } from "cms/rich-text/richtext-utils";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ImageListItemDisplay } from "./image_list_item";

const ImageListComponentDisplay = () => {

    const ctx = useContext(ContentZoneContext);
    const { component } = ctx || {};
    const { guid, title, description, image_list } = component || {};
    const hasContent = !isEmpty(title) || !isRichTextEmpty(description) || !isEmpty(image_list);

    return (
        <Fragment>
            <EmptyContentMessage hasContent={hasContent} component={component} />
            {hasContent && (
                <Fragment>
                    <h2>{title}</h2>
                    {hasContent && <RichTextPreview richtext={description} />}
                    <div className='blocks'>
                        <div id={`image-list-${guid}`} className='block block-bean'>
                            <div className='content'>
                                <div>
                                    {isArrayNotEmpty(image_list) &&
                                        image_list.map((item, index) => (
                                            <ImageListItemDisplay
                                                key={index}
                                                item={item}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};
ImageListComponentDisplay.displayName = "ImageListComponentDisplay";
export { ImageListComponentDisplay };
